import axios from 'axios';
import { API, GENERAL } from '../constants';
import { models, types } from '../types';

const statusHttpCreated = 201;
export const instance = axios.create({
    baseURL: GENERAL.API_HOSTNAME,
});

instance.interceptors.response.use(
    response => response,
    error => {
        if (!error.response.ok) {
            throw new Error(GENERAL.API_ERROR);
        }
        return error;
    }
)

export const getDictionary = () => instance.get(API.DICTIONARY);

export const getSchools = (model: models.TSchools) => {
    let parameters = '';
    if (model.page) {
        const page = `page=${model.page}`;
        parameters = parameters ? `${parameters}&${page}` : page;
    }
    if (model.city) {
        const city = `search[city]=${model.city}`;
        parameters = parameters ? `${parameters}&${city}` : city;
    }
    if (model.street) {
        const street = `search[street]=${model.street}`;
        parameters = parameters ? `${parameters}&${street}` : street;
    }
    if (model.zipCode) {
        const zipCode = `search[zipCode]=${model.zipCode}`;
        parameters = parameters ? `${parameters}&${zipCode}` : zipCode;
    }
    if (model.isRemoveSecondarySchool) {
        const level = `search[levels][]=1&search[levels][]=2&search[levels][]=3`;
        parameters = parameters ? `${parameters}&${level}` : level;
    }
    const API_URL = API.SCHOOLS + (parameters ? `?${parameters}` : '');
    return instance.get(API_URL);
};

export const getPublisher = (model: models.TPublisher) => {
    const API_URL = API.PUBLISHER.replace(':subjectId', model.subjectId).replace(':schoolLevelId', model.schoolLevelId);
    return instance.get(API_URL);
};

export const postTeacher = (model: types.TTeacher) => instance.post(API.TEACHER, model).then(function (r) {
  if (r.status !== statusHttpCreated) {
      throw new Error(GENERAL.API_ERROR);
  }
});
